// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"d0430089","344":"20a8c6f1","439":"babb4551","608":"11427db3","711":"790f570d"}[chunkId] + ".chunk.js";
};